<div class="flex h-full flex-col gap-4" *transloco="let t">
  <ITabs [tabs]="tabs()" [(activeTab)]="activeTab" />

  <div class="flex flex-1 flex-col gap-2">
    @if (activeTab() === SeedType.Keyword) {
      <div class="flex-1">
        @if (modalData.whitelist) {
          <app-keyword-list-manager
            [maxWordPerKeyword]="MAX_WORD_PER_KEYWORD"
            [targetingMode]="false"
            [addInputPlaceholder]="t('keyword-segment-modal.keyword_input_placeholder', [MAX_WORD_PER_KEYWORD])"
            [maxKeywords]="MAX_KEYWORDS"
            [initTargetings]="initWhitelistedKeywords()"
            [isReadOnly]="!!isReadOnly()"
            (targetingsChanged)="keywordTargetingsChanged($event)"
          />
        } @else {
          <app-keyword-list-manager
            [initTargetings]="initBlacklistedKeywords()"
            [maxKeywords]="MAX_KEYWORDS"
            [isReadOnly]="!!isReadOnly()"
            (targetingsChanged)="keywordTargetingsChanged($event)"
          />
        }
      </div>
    } @else {
      <div class="flex justify-end gap-2">
        @if (productToRemove().length > 0) {
          <button iButton variant="destructive" size="sm" (click)="saveProducts()">
            <IIcon name="trash" />
            {{ t("common.remove") }}
          </button>
        }
        <button iButton size="sm" (click)="openAddProductsModal()">
          <IIcon name="add" />
          {{ t("common.add") }}
        </button>
      </div>
      <div class="flex-1">
        <app-asin-selection
          [withBulk]="false"
          [allowOtherCatalog]="true"
          [(selectedAsins)]="productToRemove"
          [customList]="modalData.whitelist ? initWhitelistedProducts() : initBlacklistedProducts()"
        />
      </div>
    }
  </div>

  <ng-template #addProductsModal>
    <div class="flex h-full flex-col gap-2">
      <IAlert [title]="t('asins-selection.use_bulk_to_select_outside_catalog')" />
      <div class="min-h-0 flex-1">
        <app-asin-selection
          (selectedAsinsChange)="productToAddChanged($event)"
          [allowOtherCatalog]="true"
          [disabledAsins]="disabledAsins()"
        />
      </div>
      <div class="flex justify-end gap-2">
        <button iButton variant="secondary" size="sm" (click)="addProductsModalRef?.close()">
          {{ t("common.cancel") }}
        </button>
        <button iButton size="sm" [loading]="loading()" (click)="saveProducts()">{{ t("common.save") }}</button>
      </div>
    </div>
  </ng-template>

  <div class="flex justify-end gap-2" *transloco="let t">
    <button iButton variant="secondary" size="sm" (click)="close()">{{ t("common.close") }}</button>

    @if (activeTab() === SeedType.Keyword) {
      <button iButton size="sm" [loading]="loading()" (click)="save()">{{ t("common.save") }}</button>
    }
  </div>
</div>
